<template>
  <div class="flex items-center cursor-pointer border-b is-last:border-b-0">
    <div class="py-4 flex flex-1 items-center max-w-full">
      <div class="flex-1 last:mb-0 min-w-0">
        <p class="text-gray-600">
          {{ formattedNumId }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { formatNumUriString } from "@/utils/utils";

export default {
  name: "KeywordResultsItem",
  props: {
    keywordResult: Object,
  },
  data() {
    return {
      moduleId: 1,
    };
  },
  computed: {
    formattedNumId() {
      return formatNumUriString(this.keywordResult.numUri);
    },
  },
};
</script>
